import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["title", "description", "titleInput", "descriptionInput"]

  connect() {
    this.updatePreview()
  }

  updatePreview() {
    this.updateTitle()
    this.updateDescription()
  }

  updateTitle() {
    if (this.hasTitleInputTarget && this.hasTitleTarget) {
      const titleText = this.titleInputTarget.value || "Untitled Page"
      this.titleTarget.textContent = titleText
      this.updateCharacterCount(this.titleInputTarget, 30, 60)
    }
  }

  updateDescription() {
    if (this.hasDescriptionInputTarget && this.hasDescriptionTarget) {
      const descText = this.descriptionInputTarget.value || "No description provided"
      this.descriptionTarget.textContent = descText
      this.updateCharacterCount(this.descriptionInputTarget, 120, 160)
    }
  }

  updateCharacterCount(input, minChars, maxChars) {
    const length = input.value.length
    const counter = input.closest('.mb-6')?.querySelector('.char-count')

    if (counter) {
      const charText = `${length} / ${maxChars} chars`
      counter.textContent = charText

      // Color coding
      counter.classList.remove('text-red-600', 'text-yellow-600', 'text-green-600')

      if (length >= minChars && length <= maxChars) {
        counter.classList.add('text-green-600')
      } else if (length > 0 && length < minChars) {
        counter.classList.add('text-yellow-600')
      } else if (length > maxChars) {
        counter.classList.add('text-red-600')
      } else {
        counter.classList.add('text-red-600')
      }
    }
  }
}
